export type SortSlug = "featured" | "best-selling" | "newest" | "price-asc" | "price-desc";

export const sortOptions: { slug: SortSlug; label: string }[] = [
  { slug: "featured", label: "Featured" },
  { slug: "best-selling", label: "Best selling" },
  { slug: "newest", label: "Newest" },
  { slug: "price-asc", label: "Price, low to high" },
  { slug: "price-desc", label: "Price, high to low" },
];

export function parseSort(value: string | string[] | undefined): SortSlug {
  const slug = Array.isArray(value) ? value[0] : value;
  return sortOptions.find((o) => o.slug === slug)?.slug ?? "featured";
}
